import { clsx, type ClassValue } from "clsx"
import { twMerge } from "tailwind-merge"

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}

import i18n from '@/i18n';

export function formatCurrency(amount: number, currency: string = 'USD') {
  return new Intl.NumberFormat(i18n.language || 'es-ES', {
    style: 'currency',
    currency: currency,
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  }).format(amount);
}

export function getCurrencySymbol(currency: string): string {
  const symbols: { [key: string]: string } = {
    USD: '$',
    CRC: '₡',
    EUR: '€',
    MXN: '$',
    COP: '$'
  };
  return symbols[currency] || '$';
}
